import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modal: { show: false, initialData: null },
};

const calculadoraSlice = createSlice({
  name: "calculadora",
  initialState,
  reducers: {
    openCalculadoraModal: state => {
      state.modal.show = true;
      state.modal.initialData = null;
    },
    openCalculadoraModalWithData: (state, action) => {
      state.modal.show = true;
      state.modal.initialData = action.payload;
    },
    closeCalculadoraModal: state => {
      state.modal.show = false;
      state.modal.initialData = null;
    },
  },
});

export const {
  openCalculadoraModal,
  openCalculadoraModalWithData,
  closeCalculadoraModal,
} = calculadoraSlice.actions;

export default calculadoraSlice.reducer;
